
export const notFound = {
  title: "Oops! Page Not Found",
  description: "The page you're looking for doesn't exist or has been moved. Don't worry, it happens to the best of us!",
  suggestions: {
    title: "Here's what you can try:",
    checkUrl: "Check if the URL is spelled correctly",
    tryAgain: "Refresh the page or try again later", 
    contactUs: "Contact our support team if you need help"
  },
  actions: {
    goToHome: "Go to Home",
    goToDashboard: "Go to Dashboard",
    goBack: "Go Back"
  },
  helpText: "Need assistance? Our support team is here to help you get back on track."
};
